<template>
  <div>
    <header class="row align-middle campaign-stats-overall__header">
      <div class="columns large-expand">
        <h2 class="campaign-stats-overall__title">
          {{ $t('ADVERTISEMENT.CAMPAIGN_VIEW.STATS.OVERALL.TITLE') }}
        </h2>
      </div>
      <div class="columns shrink">
        <CampaignStatsOverallCSVButton
          :range="range"
          :campaign-id="campaignId"
        />
      </div>
    </header>

    <div class="row">
      <div class="columns large-7 small-12">
        <CampaignStatsOverallChart :range.sync="range" />
      </div>
      <div class="columns large-5 small-12 campaign-stats-overall__reports">
        <CampaignStatsOverallReports :campaign-id="campaignId" />
      </div>
    </div>
  </div>
</template>

<script>
import CampaignStatsOverallChart from './CampaignStatsOverallChart';
import CampaignStatsOverallReports from './CampaignStatsOverallReports';
import CampaignStatsOverallCSVButton from './CampaignStatsOverallCSVButton';
import campaignId from '@/mixins/advertisement/campaignId';

export default {
  name: 'CampaignStatsOverall',

  components: {
    CampaignStatsOverallChart,
    CampaignStatsOverallReports,
    CampaignStatsOverallCSVButton,
  },

  mixins: [campaignId],
  data() {
    return {
      range: 'last-week',
    };
  },
};
</script>

<style lang="scss">
.campaign-stats-overall {
  &__header {
    margin-bottom: $global-margin;
  }

  &__title {
    margin-bottom: 0;
    font-size: rem-calc(18px);
  }

  &__reports {
    @include breakpoint(medium down) {
      margin-top: $global-margin;
    }
  }
}
</style>
